module.exports = __webpack_public_path__ + "static/media/m_eyeshape_almond_darkbrown.f190be66.png";